<template>
  <div>
    <h1>Schizo Synthesis (Under Construction)</h1>
    <div class="list">
      <router-link to="/unreal-self">Unreal Self</router-link>
      <router-link to="/self-emptiness">Self Emptiness</router-link>
      <router-link to="/other-negative">Other Negative</router-link>
      <router-link to="/dream-fact">Dream Fact</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<style lang="scss">
.list {
  display: flex;
  flex-direction: column;
}
</style>
